<template>
    <div style="text-align: center">
        <router-link :to="'settlements/'+row.id+'/details'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-eye"></i>
        </router-link>
    </div>
</template>

<script>
import Vue from 'vue'
import { statusStr } from '@/constants/settlementStatus'
import { settlementService } from '@/common/api.service'
import toastr from 'toastr'
import { i18n } from '@/plugins/i18n'
import $ from "jquery";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    }
})
</script>